import { all, put, takeLatest } from 'redux-saga/effects';

import {
  addressSuccess,
  addressFailure,
  addressRequest,
  updateAddressRequest,
  updateAddressSuccess,
  updateAddressFailure,
} from './actions';
import axios from 'axios';
import { ADDRESSES } from 'app/api-routes';

function* addressSaga({ payload: { tableName, entityID } }) {
  try {
    const { payload, warnings } = yield axios.get(`${ADDRESSES}/${tableName}/${entityID}`);

    if (payload) {
      yield put(addressSuccess(payload, { warnings }));
    }
  } catch (err) {
    yield put(addressFailure(err));
  }
}

function* updateAddressSaga({ payload: { tableName, entityID, payload } }) {
  try {
    yield axios.put(`${ADDRESSES}/${tableName}/${entityID}`, { payload });

    yield put(updateAddressSuccess(payload));
  } catch (err) {
    yield put(updateAddressFailure(err));
  }
}

export default function* () {
  yield all([
    yield takeLatest(addressRequest, addressSaga),
    yield takeLatest(updateAddressRequest, updateAddressSaga),
  ]);
}
